export const TRANSFER_STATES = {
  STARTED: 'started',
  PAUSED: 'paused',
  DOWNLOADABLE: 'downloadable',
  DOWNLOADING: 'downloading',
  FINISHED: 'finished',
  PROCESSING: 'processing',
};
